/* @file context for the package.
 * */
import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import EBABTheme from './styles/theme';

/* User Context
 * This context keeps a global state for information around the user currently logged in.
 *
 * Please use the ContextWrapper to initialise the context for child components.
 * */
export const UserContext = createContext(null);

/* Application context wrapper
 *  Top layer component which wraps the application to contain a User context.
 * */
export const UserContextWrapper = ({ children }) => {
    const [user, setUser] = React.useState({});
    const userState = React.useMemo(
        () => ({ user: user, setUser: setUser }),
        [user]
    );
    return (
        <UserContext.Provider value={userState}>
            {children}
        </UserContext.Provider>
    );
};

UserContextWrapper.propTypes = {
    children: PropTypes.object.isRequired
};

/** @component
 * Wraps children in our theme.
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export const ThemeContextWrapper = ({ children }) => {
    return <ThemeProvider theme={EBABTheme}>{children}</ThemeProvider>;
};

ThemeContextWrapper.propTypes = {
    children: PropTypes.any.isRequired
};
